module.exports = __webpack_public_path__ + "static/media/vehicleImage.084c2968.svg";